import { DisclaimerType } from "@/components/molecules/FooterDisclaimer/types";

export type CopyrightType = "A" | "B";

const buildType = (disclaimer: DisclaimerType, copyright: CopyrightType) => ({
  disclaimer,
  copyright,
});

const FOOTER_TYPE: Record<string, ReturnType<typeof buildType>> = {
  A: buildType("A", "A"),
  B: buildType("B", "A"),
  C: buildType("C", "A"),
  D: buildType("D", "B"),
  E: buildType("E", "A"),
  F: buildType("F", "B"),
};

export const useGetFooterType = () => {
  const {
    footer: { type },
  } = require("../../../../config/default");
  let data: Record<string, ReturnType<typeof buildType>> = {};

  Object.keys(type).forEach((key) => {
    data[key] = FOOTER_TYPE[type[key].toUpperCase()];
  });

  return data;
};
